export class Component {
  constructor(element) {
    this.element = element;
    this._loaded = false;
    this._initialised = false;
  }

  getAttribute(name, fallbackValue = null) {
    const v = this.element.getAttribute(name);

    if (v) {
      return v;
    } else {
      return fallbackValue;
    }
  }

  getData(name, fallbackValue = null) {
    return this.getAttribute("data-" + name, fallbackValue);
  }

  getDataInt(name, fallbackValue = null) {
    const x = this.getData(name, fallbackValue);
    return parseInt(x);
  }

  init() {}

  load() {}

  $(selector = null) {
    if (selector !== null) {
      return $(this.element).find(selector);
    } else {
      return $(this.element);
    }
  }

  destroy() {
    delete this;
  }

}

class ComponentRegistration {
  constructor(type, query) {
    this.query = query;
    this.type = type;
  }

}

export class Components {
  static staticConstructor() {
    this._instances = [];
    this._registry = [];
  }

  static update(scopeElement) {
    this.bind(scopeElement);
    this.init();
    this.load();
  }

  static setup() {
    this.bind();
    window.addEventListener('DOMContentLoaded', event => {
      this.init();
    });
    window.addEventListener('load', event => {
      this.load();
    });
  }

  static load() {
    this._instances.forEach(instance => {
      if (!instance._loaded) {
        instance._loaded = true;
        instance.load();
      }
    });
  }

  static init() {
    this._instances.forEach(instance => {
      if (!instance._initialised) {
        instance._initialised = true;
        instance.init();
      }
    });
  }

  static bind(scopeElement) {
    if (!scopeElement) scopeElement = document;

    for (let i = 0; i < this._registry.length; i++) {
      let obj = this._registry[i];
      let attachedKey = "data-component-attached-" + obj.type.name;
      document.querySelectorAll(obj.query).forEach(element => {
        var isAttached = element.getAttribute(attachedKey);

        if (!isAttached) {
          element.setAttribute(attachedKey, true);
          const instance = new obj.type(element);

          this._instances.push(instance);
        }
      });
    }
  }

  static validateType(type) {
    if (type.prototype instanceof Component) {
      return true;
    } else {
      throw Error("Object " + type.prototype.name + " does not inherit from Component.");
      return false;
    }
  }

  static query(type, selector) {
    if (this.validateType(type)) {
      this._registry.push(new ComponentRegistration(type, selector));
    } else {
      throw Error("Could not register component \"" + name + "\" " + type.prototype.name);
    }
  }

  static getTagNameFromType(type) {
    let tagName = type.name;
    tagName = tagName.toLowerCase().replaceAll(" ");
    tagName.replace(/([A-Z])/g, ' $1').trim();
    tagName = tagName.replace(" ", "-");

    if (!tagName.endsWith("-component")) {
      tagName += "-component";
    }

    return tagName;
  }

  static auto(type) {
    let tagName = this.getTagNameFromType(type);
    this.query(type, tagName);
  }

  static data(type, name) {
    this.query(type, "[data-component='" + name + "']");
    this.query(type, "[data-c='" + name + "']");
  }

} // Setup static values (cannot do in constructor because it wont fire)

Components.staticConstructor();